var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1453.432,
    height: 389.169,
    viewBox: "0 0 1453.432 389.169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3191",
    d: "M3191.882,1863.978V1474.809L1738.45,1863.978Z",
    transform: "translate(-1738.45 -1474.809)",
    fill: "#4897d1",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomChart);
export default __webpack_public_path__ + "static/media/bottom_chart.3e3ef5451b8917611d42d2b8e878708a.svg";
export { ForwardRef as ReactComponent };